import{tokens as e}from"./tokens/index.mjs";import{breakpoints as o}from"./breakpoints.mjs";var t={tokens:e,breakpoints:o,name:"default-theme"};export{t as defaultTheme};
